import React from 'react'
import NoSSR from 'react-no-ssr'
import { convertStringToDate, getDateString } from '../../utils/timeHelpers'
import ThemeCountDown from './ThemeCountDown'

const CountDown = (props) => {
  const {
    content: {
      date,
      time = '00:00:00',
      timeoutMessage = {},
    } = {},
    currentLang,
    style,
    settings,
    renderElement,
  } = props
  const dateValue = getDateString(date)
  const endTime = convertStringToDate(`${dateValue} ${time}`, 'YYYY-MM-DD HH:mm:ss').getTime()
  return (
    renderElement(
      (rest) => (
        <NoSSR>
          <ThemeCountDown {...rest} />
        </NoSSR>
      ),
      {
        style,
        endTime,
        timeoutMessage: timeoutMessage[currentLang],
        settings,
      },
    )
  )
}

CountDown.propTypes = {}
CountDown.defaultProps = {}

export default CountDown



// WEBPACK FOOTER //
// ./src/components/Canvas/renderer/elements/countDown/CountDown.js